import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();
  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      {/* Background Image */}
      <img
        src="https://readdy.ai/api/search-image?query=Beautiful%20sunset%20over%20Ha%20Long%20Bay%20Vietnam%20with%20traditional%20wooden%20junk%20boats%20sailing%20on%20calm%20emerald%20water%20limestone%20islands%20silhouettes%20golden%20orange%20sky%20travel%20inspiration%20peaceful%20serene%20atmosphere&width=1800&height=700&seq=about-cta-bg&orientation=landscape"
        alt={t('about.ctaAlt')}
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-black/50" />

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center">
        <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
          {t('about.ctaTitle')}
        </h2>
        <p className="text-white/80 text-sm md:text-base max-w-lg mx-auto mb-8">
          {t('about.ctaSubtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/tours"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-accent-500 text-white font-medium text-sm rounded-full hover:bg-accent-600 transition-colors whitespace-nowrap"
          >
            {t('about.browseTours')}
            <i className="ri-arrow-right-line" />
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-7 py-3.5 border border-white/40 text-white font-medium text-sm rounded-full hover:bg-white/10 transition-colors whitespace-nowrap"
          >
            {t('about.contactUs')}
            <i className="ri-mail-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}